module.exports = __webpack_public_path__ + "img/Click.0c5f2735.svg";